import React from 'react';
import pt from 'prop-types';
import semver from 'semver';
import Link from 'components/link';
import Side from 'components/view/side';
import StoreIcon from 'components/store/icon';
import AppStatus from './status';
import PartnerPayoutStatus from 'admin/components/partner/payout-status';
import FrameworkIcons from 'components/storefront/framework-icons';
import { formatDate, formatTableValue } from 'utils';
import { renderAppTypeLabel } from 'utils/app';

export default class AppDetails extends React.PureComponent {
  static propTypes = {
    app: pt.object,
    showPayouts: pt.bool,
  };

  render() {
    const { app, showPayouts = true } = this.props;
    const {
      partner_id,
      partner,
      client,
      published_props,
      publishable_versions,
      version,
      _version,
      installs,
    } = app;

    const latestVersion = _version || version;
    const publishableVersion = publishable_versions?.results?.[0];
    const latestRelease =
      publishableVersion &&
      (!published_props?.version ||
        semver.compare(publishableVersion?.version, published_props.version) >
          0)
        ? publishableVersion
        : null;

    const owner = partner_id ? partner : client;

    return (
      <Side>
        <div className={`store-user view-side-container`}>
          {owner && (
            <section className="view-side-section">
              <div className="store-user-avatar">
                <Link to={`/${partner_id ? 'partners' : 'stores'}/${owner.id}`}>
                  <StoreIcon store={owner} size={45} />
                </Link>
              </div>
              <h4 className="view-side-customer-name">{owner.id}</h4>
              <div>{owner.support_email}</div>
            </section>
          )}
          {app.published ? (
            <section className="view-side-section">
              <div className="view-side-section-header">
                <h4>Public ID</h4>
              </div>
              <div className="view-side-body">
                {app.public_id ? (
                  <span className="monospaced">{app.public_id}</span>
                ) : (
                  formatTableValue()
                )}
              </div>
            </section>
          ) : (
            <section className="view-side-section">
              <div className="view-side-section-header">
                <h4>Private ID</h4>
              </div>
              <div className="view-side-body">
                <span className="monospaced">{app.private_id}</span>
              </div>
            </section>
          )}
          <section className="view-side-section">
            <div className="view-side-section-header">
              <h4>Type</h4>
            </div>
            <div className="view-side-body">{renderAppTypeLabel(app.type)}</div>
          </section>
          {showPayouts && partner && (
            <section className="view-side-section">
              <div className="view-side-section-header">
                <h4>Payouts</h4>
              </div>
              <div className="view-side-body">
                <PartnerPayoutStatus partner={partner} />
              </div>
            </section>
          )}
          <section className="view-side-section">
            <div className="view-side-section-header">
              <h4>Status</h4>
            </div>
            <div className="view-side-body">
              <AppStatus app={app} />
            </div>
          </section>
          {app.published_props?.version && (
            <section className="view-side-section">
              <div className="view-side-section-header">
                <h4>Published version</h4>
              </div>
              <div className="view-side-body">
                <Link
                  to={`/apps/${app.id}?version=${app.published_props.version}`}
                >
                  {app.published_props.version}
                </Link>
              </div>
            </section>
          )}
          {latestRelease && (
            <section className="view-side-section">
              <div className="view-side-section-header">
                <h4>Latest release</h4>
              </div>
              <div className="view-side-body">
                <Link to={`/apps/${app.id}?version=${latestRelease.version}`}>
                  {latestRelease.version}
                </Link>
              </div>
            </section>
          )}
          <section className="view-side-section">
            <div className="view-side-section-header">
              <h4>Latest version</h4>
            </div>
            <div className="view-side-body">
              <Link to={`/apps/${app.id}?version=${latestVersion}`}>
                {latestVersion}
              </Link>
            </div>
          </section>
          {app.storefront?.frameworks && (
            <section className="view-side-section">
              <div className="view-side-section-header">
                <h4>Languages / frameworks</h4>
              </div>
              <div className="view-side-body">
                <FrameworkIcons frameworks={app.storefront.frameworks} />
              </div>
            </section>
          )}
          {installs?.count !== undefined && (
            <section className="view-side-section">
              <div className="view-side-section-header">
                <h4>Installs</h4>
              </div>
              <div className="view-side-body">{installs.count}</div>
            </section>
          )}
          <section className="view-side-section">
            <div className="view-side-section-header">
              <h4>Created</h4>
            </div>
            <div className="view-side-body">
              {formatDate(app.date_created, 'longDate')}
            </div>
          </section>
        </div>
      </Side>
    );
  }
}
